import { render } from "./AvisoPush.vue?vue&type=template&id=91cfa35e"
import script from "./AvisoPush.vue?vue&type=script&lang=js"
export * from "./AvisoPush.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__